export const licenseReportInitialValues = {
  servicos: [],
  polos: [],
  dtEmissao: { dtInicio: '', dtFim: '' },
  dtVencimento: { dtInicio: '', dtFim: '' },
  dePlaca: '',
  nmOperador: '',
  nuDocumentoOperador: '',
  nmProprietario: '',
  nuDocumentoProprietario: '',
  cdSetor: 1,
  usuarios: [],
  setores: [],
  nuSolicitacao: '',
  nuLicenca: '',
  situacaoCrc: 3,
  agrupamento: 0,
  boExibirResumo: true,
};
